"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var react_dom_1 = __importDefault(require("react-dom"));
var app_1 = __importDefault(require("firebase/app"));
require("firebase/firestore");
require("firebase/auth");
require("firebase/storage");
require("firebase/analytics");
require("./styles/main.scss");
var app_2 = __importDefault(require("./app"));
var auth_service_1 = __importDefault(require("./services/auth.service"));
var lang_service_1 = __importDefault(require("./services/lang.service"));
var firebaseConfig = {
    apiKey: "AIzaSyBWIwOgHx9P7xZBHyCm7VwL6wO8n8pWG_c",
    authDomain: "comixtopia-2021.firebaseapp.com",
    projectId: "comixtopia-2021",
    storageBucket: "comixtopia-2021.appspot.com",
    messagingSenderId: "342060493540",
    appId: "1:342060493540:web:787c7ba394e10bbd72daf1",
    measurementId: "G-DYCSDMP4WV",
};
var init = function () { return __awaiter(void 0, void 0, void 0, function () {
    var appRoot, err_1;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                app_1.default.initializeApp(firebaseConfig);
                app_1.default.analytics();
                return [4, auth_service_1.default.initialize()];
            case 1:
                _a.sent();
                lang_service_1.default.initialize();
                appRoot = document.getElementById('root');
                if (appRoot)
                    react_dom_1.default.render(react_1.default.createElement(app_2.default), appRoot);
                return [3, 3];
            case 2:
                err_1 = _a.sent();
                debugger;
                return [3, 3];
            case 3: return [2];
        }
    });
}); };
init();
